module.exports = __webpack_public_path__ + "static/media/invest-monitor.75dfa2d4.svg";